import { render, staticRenderFns } from "./TenantsLayout.vue?vue&type=template&id=22c39c71&"
import script from "./TenantsLayout.vue?vue&type=script&lang=js&"
export * from "./TenantsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports